import { createContext } from 'react'

interface ConfigContextType {
    title: string
}

export const ConfigContext = createContext<ConfigContextType>(null!)